<template>
  <FormField
    v-if="control"
    :id="id"
    :control="control"
    :label="label"
    :required="required">
    <input
      :id="id"
      :name="name"
      type="text"
      :class="{ 'form-control': true, input: true, 'is-danger': control.invalid && control.dirty }"
      :value="control.value"
      @input="updateValue"
      @keyup.enter="onEnterPressed" />
  </FormField>
</template>

<script setup lang="ts">
  import AbstractFormControl from '@/common/components/generic-form/form-controls/AbstractFormControl';

  import FormField, { IGenericFormFieldProps } from './FormField.vue';

  interface ITextFormFieldProps extends IGenericFormFieldProps<string> {
    control: AbstractFormControl<string>;
    name: string;
  }

  interface ITextFormFieldEmits {
    (e: 'valueChanged', value: string);
    (e: 'enterPressed');
  }

  const props = defineProps<ITextFormFieldProps>();
  const emit = defineEmits<ITextFormFieldEmits>();

  function updateValue(payload: Event) {
    const inputElement = payload.target as HTMLInputElement;
    props.control.update(inputElement.value);
    emit('valueChanged', props.control.value);
  }

  function onEnterPressed() {
    emit('enterPressed');
  }
</script>
